export const DEAL_INSIGHTS_V2_PATH = '/deal-insights-v2';

export const DEAL_INSIGHTS_V2_PATHS = {
  general: '',
  geolocation: 'geolocation',
};

export const DEAL_INSIGHTS_V2_TABS = [
  { name: 'General', path: DEAL_INSIGHTS_V2_PATHS.general },
  { name: 'Geolocation', path: DEAL_INSIGHTS_V2_PATHS.geolocation },
];
